
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/web/images/logo.png";
import design1 from "../assets/web/images/design-1.png";
import design2 from "../assets/web/images/design-2.png";
import bg from "../assets/web/images/ivo-bg.png";
import { WebAssetsContext } from "../App";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import { errorToast, successToast , alertDanger , alertSuccess } from "../functions/Function";
const Webassetscss = React.lazy(() => import('../Webassets'));

const Signup = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [inputs, setInputs] = useState({});
  const [validation, setValidation] = useState(null);
  const [alert, setAlert] = useState(null);
  const [verifybtn, setverifybtn] = useState('Send Code');
  const [verifiycode, setverifiycode] = useState(false);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({ ...values, [name]: value }))
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(api + "signup", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();

      setDisabled(false);
      if (res.status === 200) {
        setAlert(null)
        setValidation(null)
       
        if (output.result == true) {
          setInputs({});
          setAlert(alertSuccess('Account created successfully'));
          setTimeout(() => {
              navigate("/login");
          }, 3000);
        } else {
          if (output.validation == true) {
            setValidation(output.response)
          } else {
            errorToast(output.response, 'top-right', 3000, true);
          }
        }

      }
    } catch (err) {
      setDisabled(false);
    }
  }

  

  const handleSendVerificationCode = async () => {
    setverifybtn('Send Code...');
    try {
      let res = await fetch(api + "sendOtpOnEmail", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();
      setDisabled(false);
      if (res.status === 200) {
        setverifybtn('Resend Code');
        if (output.result == true) {
            setverifiycode(true);
            successToast(output.response, 'top-right', 4000, true);
        } else {
          if (output.validation == true) {
            errorToast(output.response, 'top-right', 4000, true);
          } else {
            
            errorToast(output.response, 'top-right', 4000, true);
          }
        }

      }
    } catch (err) {
      setDisabled(false);
    }
  }
  return (
    <>
    <ToastContainer />
      <Suspense>
        <Webassetscss />
        <section style={{
          backgroundImage: `url("${bg}")`
        }} className="ivo-section ivo-login-page">
          <div className="ivo-design-2">
            <img className="img-fluid" src={design1} alt="d-1" />
          </div>
          <div className="container">
            <div className="ivo-shadow-box ivo-login-box ivo-ovrflow-hidden">
              <div className="ivo-external-heading text-center">
                <h5 className="ivo-before-login-heading">Sign Up to Ivoire</h5>
              </div>
              <hr />
              {alert}
              <form method="POST" onSubmit={handleSubmit}>
                <div className="ivo-login-middle">

                  <div className="form-group">
                    <label>Name</label>
                   <input
                      type="text"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Name"
                      className="form-control"
                    />
                     {validation != null && validation.name != '' ?  <p className="erAlert text-danger  ">{validation.name}</p> : ''} 
                     
                  </div>
                 
                   
                        <div className="form-group">
                          <label>Email</label>
                              <div className="emailVerfiyField">
                                <input
                                  type="text"
                                  name="email"
                                  value={inputs.email || ""}
                                  onChange={handleChange}
                                  placeholder="Email"
                                  className="form-control"
                                />
                                <button onClick={() => handleSendVerificationCode()} type="button" className="emailotpsendBtn">{verifybtn}</button>
                            </div>
                            {validation != null && validation.email != '' ?  <p className="erAlert text-danger emailEr ">{validation.email}</p> : ''} 
                        </div>
                       
                        <div className="form-group">
                        <label>Verification Code</label>
                        <input
                          type="text"
                          name="code"
                          value={inputs.code || ""}
                          onChange={handleChange}
                          placeholder="Verification Code"
                          className="form-control"
                        />
                        {validation != null && validation.code != '' ?  <p className="erAlert text-danger  ">{validation.code}</p> : ''}
                        </div>
                       
                        
                    
                  

                  <div className="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      name="password"
                      value={inputs.password || ""}
                      onChange={handleChange}
                      placeholder="Password"
                      className="form-control"
                    />
                    {validation != null && validation.password != '' ?  <p className="erAlert text-danger  ">{validation.password}</p> : ''} 

                  </div>
                  <div className="form-group">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      name="confirm_password"
                      value={inputs.confirm_password || ""}
                      onChange={handleChange}
                      placeholder="Confirm Password"
                      className="form-control"
                    />
                   
                   {validation != null && validation.confirm_password != '' ?  <p className="erAlert text-danger  ">{validation.confirm_password}</p> : ''} 
                  </div>

                </div>
                <hr />

                <div className="ivo-login-footer">
                
                  <button className="btn ivo-site-btn" type="submit" disabled={disabled}> {disabled == false ? 'Sign Up' : 'Creating account...'} </button>
                  <div className="ivo-login-links">
                    <Link to="/login">Back to Login</Link>

                  </div>
                </div>
              </form>

            </div>
          </div>
          <div className="ivo-design-1">
            <img className="img-fluid" src={design2} alt="d-2" />
          </div>
        </section>




      </Suspense>
    </>

  );
}

export default Signup;
